export const translations = {
  es: {
    nav: {
      map: 'Mapa',
      publish: 'Publicar',
      myProperties: 'Mis Propiedades',
      tasks: 'Mis Tareas',
      knowledge: 'Conocimiento',
      invest: 'Invertir',
      crm: 'Organización',
      community: 'Comunidad',
      messages: 'Mensajería',
      profile: 'Mi Perfil',
      admin: 'Dashboard Admin'
    },
    common: {
      loading: 'Cargando...',
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      create: 'Crear',
      search: 'Buscar',
      filter: 'Filtrar',
      upgrade: 'Mejorar Plan',
      logout: 'Cerrar Sesión'
    },
    plans: {
      free: 'Gratuito',
      basic: 'Básico',
      premium: 'Premium',
      freeLimits: 'Máx 2 propiedades',
      basicFeatures: 'Propiedades ilimitadas + AI 24/7',
      premiumFeatures: 'CRM Avanzado + Organigrama'
    },
    property: {
      type: 'Tipo',
      price: 'Precio',
      bedrooms: 'Habitaciones',
      bathrooms: 'Baños',
      area: 'Superficie',
      location: 'Ubicación',
      description: 'Descripción'
    },
    errors: {
      propertyLimit: 'Has alcanzado el límite de 2 propiedades del plan gratuito',
      requireBasic: 'Esta funcionalidad requiere plan Básico o Premium',
      requirePremium: 'Esta funcionalidad es exclusiva del plan Premium'
    }
  },
  en: {
    nav: {
      map: 'Map',
      publish: 'Publish',
      myProperties: 'My Properties',
      tasks: 'My Tasks',
      knowledge: 'Knowledge',
      invest: 'Invest',
      crm: 'Organization',
      community: 'Community',
      messages: 'Messages',
      profile: 'My Profile',
      admin: 'Admin Dashboard'
    },
    common: {
      loading: 'Loading...',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      search: 'Search',
      filter: 'Filter',
      upgrade: 'Upgrade Plan',
      logout: 'Logout'
    },
    plans: {
      free: 'Free',
      basic: 'Basic',
      premium: 'Premium',
      freeLimits: 'Max 2 properties',
      basicFeatures: 'Unlimited properties + 24/7 AI',
      premiumFeatures: 'Advanced CRM + Organigram'
    },
    property: {
      type: 'Type',
      price: 'Price',
      bedrooms: 'Bedrooms',
      bathrooms: 'Bathrooms',
      area: 'Area',
      location: 'Location',
      description: 'Description'
    },
    errors: {
      propertyLimit: 'You have reached the 2 property limit of the free plan',
      requireBasic: 'This feature requires Basic or Premium plan',
      requirePremium: 'This feature is exclusive to Premium plan'
    }
  }
};
